import { render, staticRenderFns } from "./PackageBuilder.vue?vue&type=template&id=168720a4&"
import script from "./PackageBuilder.vue?vue&type=script&lang=js&"
export * from "./PackageBuilder.vue?vue&type=script&lang=js&"
import style0 from "./PackageBuilder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports